import { useContext, useState } from "react";
import { glassItems } from "../utils/symbols";
import { AppContext } from "../App";

export const DamageGlassSelector = () => {
	const { data, setData } = useContext(AppContext);
	const [hoveredGlass, setHoveredGlass] = useState(null);

	const selectGlass = (glassName) => {
		setData((data) => ({
			...data,
			damageGlass: glassName,
			damageArea:
				glassName !== "Parabrisas delantero" ? "replacement" : null,
		}));
	};

	return (
		<svg
			id="car_schema"
			data-name="car schema"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 394 349"
		>
			<image
				width="788"
				height="698"
				transform="scale(.5)"
				href="resources/img/damage_glass.png"
			/>

			{glassItems.map((item) => {
				const isSelected = data.damageGlass === item.glassName;
				const isHovered = hoveredGlass === item.glassName;
				const isDeselected =
					(data.damageGlass || hoveredGlass) &&
					!isSelected &&
					!isHovered;

				return (
					<g
						key={item.id}
						id={`item_${item.id}`}
						className={
							isSelected || isHovered
								? "selected-glass kensei_03"
								: isDeselected
								? "deselected-glass kensei_03"
								: "default-glass"
						}
						data-name={`item ${item.id}`}
						onMouseEnter={() => setHoveredGlass(item.glassName)}
						onMouseLeave={() => setHoveredGlass(null)}
						onPointerDown={() => selectGlass(item.glassName)}
					>
						{item.areaPoints && (
							<polygon
								id="area"
								className={
									isDeselected ? "cls-deselected" : "cls-4"
								}
								points={item.areaPoints}
							/>
						)}
						{item.glassPath && (
							<g id="glass">
								<path
									className={
										isSelected || isHovered
											? "cls-selected kensei_03"
											: isDeselected
											? "cls-deselected kensei_03"
											: "cls-3 kensei_03"
									}
									d={item.glassPath}
								/>
							</g>
						)}
						{item.detailPath && (
							<path
								id="detail"
								className={
									isSelected || isHovered
										? "cls-selected kensei_03"
										: isDeselected
										? "cls-deselected kensei_03"
										: "cls-1 kensei_03"
								}
								d={item.detailPath}
							/>
						)}
						{item.detailRect && (
							<rect
								id="detail-rect"
								className={
									isSelected || isHovered
										? "cls-selected kensei_03"
										: "cls-deselected kensei_03"
								}
								x={item.detailRect.x}
								y={item.detailRect.y}
								width={item.detailRect.width}
								height={item.detailRect.height}
							/>
						)}
					</g>
				);
			})}
		</svg>
	);
};
